import SiteHeader from "@/pages/home/components/SiteHeader";
import HeroGrid from "@/pages/home/components/HeroGrid";
import CollectionIndex from "@/pages/home/components/CollectionIndex";
import TopicWall from "@/pages/home/components/TopicWall";
import FeedSection from "@/pages/home/components/FeedSection";
import TimelineStrip from "@/pages/home/components/TimelineStrip";
import PackSection from "@/pages/home/components/PackSection";
import SubscribeBand from "@/pages/home/components/SubscribeBand";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div id="top" className="min-h-screen w-full bg-background-50 text-foreground-950">
      <SiteHeader />
      <main>
        <HeroGrid />
        <CollectionIndex />
        <TopicWall />
        <FeedSection />
        <TimelineStrip />
        <PackSection />
        <SubscribeBand />
      </main>
      <SiteFooter />
    </div>
  );
}